import { shallowRef, ref } from 'vue';

/**
 * Page-context registry for the v3 contextual drawer (ui_layout='V2').
 *
 * Vue 2.7 has no Teleport and rm-portal has no portal-vue, so a new-styled page
 * contributes its own drawer content (e.g. All Jobs' Search & Explore filters,
 * hierarchy navigation) by REGISTERING a component here on mount and clearing it
 * on unmount. The ContextDrawer renders it beneath the router sub-nav.
 *
 * Module-level singleton so the page and the persistent drawer share one slot.
 */
const contextComponent = shallowRef(null);
const contextProps = ref({});

export function useV3Drawer() {
  function setDrawerContext(component, props = {}) {
    contextComponent.value = component || null;
    contextProps.value = props || {};
  }
  function clearDrawerContext() {
    contextComponent.value = null;
    contextProps.value = {};
  }
  return { contextComponent, contextProps, setDrawerContext, clearDrawerContext };
}
